module.exports = __webpack_public_path__ + "static/media/reuma2-nav.f00553a9.png";